import gql from "graphql-tag";
import CommentOrReplyAuthorFields from "./CommentOrReplyAuthorFields";

export default gql`
  fragment AssetDiscussionCommentParticipantsFields on AssetDiscussionCommentParticipants {
    nodes {
      ...CommentOrReplyAuthorFields
    }
    totalCount
  }

  ${CommentOrReplyAuthorFields}
`;
